import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/sections/HeroSection';
import ProblemSection from '../components/sections/ProblemSection';
import SolutionSection from '../components/sections/SolutionSection';
import AboutSection from '../components/sections/AboutSection';
import OffresSection from '../components/sections/OffresSection';
import FAQSection from '../components/sections/FAQSection';
import CTASection from '../components/sections/CTASection';
import Footer from '../components/Footer';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Index: React.FC = () => {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-background animate-fade-in">
      <Header />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <AboutSection />
      <OffresSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
